export const hasError = {
  type: Boolean,
  default: false,
}

export const hideSufix = {
  type: Boolean,
  default: false,
}
export const placeholder = {
  type: String,
  default: '',
}

export const options = {
  type: Array,
  default: () => [],
}
export const textClasses = {
  type: Array,
  default: () => [],
}

export const iconClasses = {
  type: String,
  default: '',
}

export const initialSelected = {
  type: Object,
  default: () => ({}),
}

export const isDisabled = {
  type: Boolean,
  default: false,
}
export const hasLocalizedLabels = {
  type: Boolean,
  default: false,
}

export const selectClasses = {
  type: [Array, String],
  default: '',
}

export const isRelative = {
  type: Boolean,
  default: false,
}
